<template>
  <div class="kanban-column col-md-3 col-sm-12">
    <div class="kanban-header">
      <h3>
        {{title}}
      </h3>
      <div>
        <span class="badge badge-info">{{taskCount}}</span>
      </div>
    </div>
    <div class="kanban-body">
      <kanban-card
        v-for="task in tasks"
        :key="task.id"
        :task="task"
        :canAssign="taskStatus === 0"
        :availableWorkers="workers[task.project.id]"
      />
    </div>
  </div>
</template>

<script>
 import KanbanCard from './KanbanCard';

 export default {
   components: {
     KanbanCard,
   },

   props: [
     'tasks',
     'taskStatus',
     'title',
     'workers',
   ],

   computed: {
     taskCount() {
       return this.tasks.length;
     },
   },
 }
</script>



// WEBPACK FOOTER //
// assets/js/components/KanbanColumn.vue